/**
 * Common "mounted" Vue.js hook for widget component if it uses charting functionality
 */
export function mounted() {
    this.chartUpdater = this.$watch(
        // watch for the following elements and re-render chart if one of them is changed
        () => [this.chartData, this.configuration, this.content, this.navCollapsed, this.isExpanded],
        () => this.makeChart(),
        { deep: true }
    );
    this.makeChart();
}

/**
 * Common "beforeDestroy" Vue.js hook for widget component if it uses charting functionality
 * Removes changes listener (watcher) set in "mounted"
 */
export function beforeDestroy() {
    if (this.chartUpdater) {
        this.chartUpdater();
    }
}
